export let ECalendarPickerPage = /*#__PURE__*/function (ECalendarPickerPage) {
  ECalendarPickerPage[ECalendarPickerPage["Month"] = 0] = "Month";
  ECalendarPickerPage[ECalendarPickerPage["Year"] = 1] = "Year";
  return ECalendarPickerPage;
}({});